










































































import Vue from 'vue';
import { Type, Expression, TupleExpression, NoExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<TupleExpression>().extend({
  name: 'TupleEditor',
  data: () => ({
    sorting: false,
  }),
  computed: {
    noop(): Expression {
      return NoExpression.instance;
    },
  },
  methods: {
    toggleSort(): void {
      this.sorting = !this.sorting;
    },
    addExpression(expr: Expression) {
      this.value.expressions.push(expr);
    },
    updateExpression(index: number, expr?: Expression) {
      if (expr) {
        this.$set(this.value.expressions, index, expr);
      } else {
        this.value.expressions.splice(index, 1);
      }

      this.update();
    },
  },
});
